var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "card search-card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "col-sm-3 col-md-2" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "search-role-name" } }, [
                _vm._v(_vm._s(_vm.i18n("Role.RoleName"))),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.roleName,
                    expression: "roleName",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "search-role-name",
                  placeholder: "請輸入關鍵字",
                },
                domProps: { value: _vm.roleName },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.getRole()
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.roleName = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "col-sm-3 col-md-3" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                staticStyle: { "margin-top": "30px", "margin-left": "10px" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.getRole()
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Search")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                staticStyle: { "margin-top": "30px", "margin-left": "10px" },
                attrs: {
                  type: "button",
                  "data-toggle": "modal",
                  "data-target": "#roleModal",
                },
                on: {
                  click: function ($event) {
                    return _vm.roleModal({ action: "add" })
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.i18n("Buttons.AddRole")) + " ")]
            ),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "yahome-table-wrap" },
      [
        _c(
          "VueBootstrap4Table",
          {
            attrs: {
              rows: _vm.rows,
              columns: _vm.columns,
              config: _vm.config,
              "total-rows": _vm.totalData,
            },
            on: { "on-change-query": _vm.changePage },
            scopedSlots: _vm._u([
              {
                key: "setMenu",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        staticStyle: { "margin-right": "0.5rem" },
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#setPermissionsModal",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.setPermissionsModal(props.row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.i18n("Role.SetUpPermission")) + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "setUser",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success btn-sm",
                        staticStyle: { "margin-right": "0.5rem" },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.setUserModal(props.row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.i18n("Role.SetUpEmployee")) + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "edit",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info btn-sm",
                        staticStyle: { "margin-right": "0.5rem" },
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#roleModal",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.roleModal({
                              action: "edit",
                              data: props.row,
                            })
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Edit")) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "delete",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn-sm",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#delRoleModal",
                        },
                        on: {
                          click: function ($event) {
                            _vm.role = props.row
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
                    ),
                  ]
                },
              },
            ]),
          },
          [_c("template", { slot: "empty-results" }, [_vm._v(" 暫無資料 ")])],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "roleModal", tabindex: "-1", "data-backdrop": "static" },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered" },
          [
            _c("ValidationObserver", {
              ref: "role",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "modal-header" }, [
                            _vm.action === "add"
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.i18n("Role.AddRole"))),
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.i18n("Role.EditRole"))),
                                ]),
                          ]),
                          _c("div", { staticClass: "modal-body" }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: {
                                    tag: "div",
                                    name: _vm.i18n("Role.RoleName"),
                                    rules: `my_not:${_vm.nowRole.Name}|required`,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "input-role-name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.i18n("Role.RoleName")
                                                  ) + " "
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("(不可重複)")]
                                                ),
                                              ]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.role.Name,
                                                  expression: "role.Name",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                id: "input-role-name",
                                              },
                                              domProps: {
                                                value: _vm.role.Name,
                                              },
                                              on: {
                                                compositionstart: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = true
                                                },
                                                compositionend: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = false
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.role,
                                                    "Name",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            errors[0] && !_vm.is_composing
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "reset",
                                  "data-dismiss": "modal",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Cancel")) + " "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.saveRole)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Save")) + " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "setPermissionsModal",
          tabindex: "-1",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.savePermissions.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c("span", [
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-primary",
                        staticStyle: { "font-size": "15px" },
                      },
                      [_vm._v(" " + _vm._s(_vm.currentRole.Name) + " ")]
                    ),
                    _vm._v(
                      " " + _vm._s(_vm.i18n("Role.SetUpPermission")) + " "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-12 col-md-6",
                        staticStyle: { height: "55vh" },
                      },
                      [
                        _c(
                          "perfect-scrollbar",
                          { staticClass: "menu-select-list" },
                          _vm._l(_vm.menu, function (mainMenu, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: { open: mainMenu.NewWindow },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "menu-name",
                                    on: {
                                      click: function ($event) {
                                        mainMenu.NewWindow = !mainMenu.NewWindow
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        " " + _vm._s(mainMenu.MenuName) + " "
                                      ),
                                    ]),
                                    _c("eva-icon", {
                                      attrs: {
                                        fill: "#000",
                                        name: "chevron-right-outline",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "option-wrap" },
                                  _vm._l(
                                    mainMenu.Children,
                                    function (subMenu, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "option",
                                          class: {
                                            active:
                                              _vm.selectedSubMenuGuid ===
                                              subMenu.Guid,
                                            hasPermission:
                                              subMenu.hasPermission &&
                                              _vm.selectedSubMenuGuid !==
                                                subMenu.Guid,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getPermissions(subMenu)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(subMenu.MenuName) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-sm-12 col-md-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "permission-select-list overflow-auto",
                          staticStyle: { height: "55vh" },
                        },
                        [
                          _vm._l(
                            _vm.subMenuPermissions,
                            function (features, index) {
                              return _c("label", { key: index }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: features.IsSelected,
                                      expression: "features.IsSelected",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(features.IsSelected)
                                      ? _vm._i(features.IsSelected, null) > -1
                                      : features.IsSelected,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = features.IsSelected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              features,
                                              "IsSelected",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              features,
                                              "IsSelected",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(features, "IsSelected", $$c)
                                      }
                                    },
                                  },
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(features.PermissionName)),
                                ]),
                                _vm._m(0, true),
                              ])
                            }
                          ),
                          _vm.subMenuPermissions.length <= 0
                            ? _c("div", [_vm._v("尚無功能")])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "button" },
                      on: { click: _vm.getPermissionsGuid },
                    },
                    [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Save")) + " ")]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "setUserModal",
          tabindex: "-1",
          "data-focus": "false",
          "data-backdrop": "static",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered modal-xl" },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("span", [
                  _c(
                    "span",
                    {
                      staticClass: "badge badge-primary",
                      staticStyle: { "font-size": "15px" },
                    },
                    [_vm._v(" " + _vm._s(_vm.currentRole.Name) + " ")]
                  ),
                  _vm._v(" " + _vm._s(_vm.i18n("Role.SetUpEmployee")) + " "),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c("kr-paging", {
                    ref: "krPaging",
                    attrs: {
                      boxTitle: ["未選取人員", "已選取人員"],
                      "filter-placeholder": ["請輸入關鍵字", "請輸入關鍵字"],
                      pageTexts: ["上一頁", "下一頁"],
                      filterable: "",
                      isHighlight: "",
                      showClearBtn: "",
                      pageSize: 50,
                      dataList: _vm.leftUser,
                      selectedData: _vm.rightUser,
                    },
                    on: { onChange: _vm.addEmployeeToRightUser },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "reset", "data-dismiss": "modal" },
                  },
                  [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.setRolesToUser()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Save")) + " ")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "delRoleModal",
          tabindex: "-1",
          "data-backdrop": "static",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm._v(_vm._s(_vm.i18n("Role.DeleteRole"))),
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _vm._v(" 確認刪除 "),
              _c(
                "span",
                { staticStyle: { "font-weight": "bolder", color: "red" } },
                [_vm._v(" " + _vm._s(_vm.role.Name) + " ")]
              ),
              _vm._v("? "),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "reset", "data-dismiss": "modal" },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.delRole },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "switch" }, [_c("span")])
  },
]
render._withStripped = true

export { render, staticRenderFns }